var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreen01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #667352;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m60.03,24H9.97c-.54,0-.98.44-.98.97v50.05c0,.54.44.98.98.98h50.05c.54,0,.97-.44.97-.98V24.97c0-.54-.44-.97-.97-.97Zm-31.57,4.67h13.08c1.07,0,1.94.87,1.94,1.94s-.87,1.94-1.94,1.94h-13.08c-1.07,0-1.94-.87-1.94-1.94s.87-1.94,1.94-1.94Zm16.27,22.83h-8.09v14.64l-1.55,5.19-1.72-5.19v-14.64h-8.09c-1.59,0-2.88-1.29-2.88-2.88s1.29-2.88,2.88-2.88h1.85l2.22-12.48h11.31l2.22,12.48h1.85c1.59,0,2.88,1.29,2.88,2.88s-1.29,2.88-2.88,2.88Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreen01);
export default __webpack_public_path__ + "static/media/green01.c4bce24dbf176927f4a26c05a0022d34.svg";
export { ForwardRef as ReactComponent };